import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * 403 page. Rendered in place by `<RequireRole>` on an insufficient effective
 * role (never a redirect — avoids loops) and also served at the public
 * `/forbidden` route. "Return home" links to the app root.
 */
export function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} sx={{ alignItems: 'flex-start', maxWidth: 480 }}>
      <Typography variant="h4" component="h1">
        {t('forbidden.title')}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        {t('forbidden.body')}
      </Typography>
      <Button component={RouterLink} to="/" variant="contained">
        {t('actions.returnHome')}
      </Button>
    </Stack>
  );
}
